import { Layout, SignInForm } from '~/components/SignIn';
import { HelmetHead } from '~/components/common';
import { Header } from '~/components/common/Header';

export default function SignIn() {
  return (
    <>
      <HelmetHead title='Sign in' />
      <Header.Root>
        <Header.Section>
          <Header.PrevButton />
        </Header.Section>
      </Header.Root>
      <Layout title={'Sign in with email'} gap={24}>
        <SignInForm />
      </Layout>
    </>
  );
}
